// Dynamic translation loader utility
// This allows for lazy loading of translations in the future if needed

import { en } from "../locales/en/index.js";
import { es } from "../locales/es/index.js";
import { bg } from "../locales/bg/index.js";
import { de } from "../locales/de/index.js";
import { fr } from "../locales/fr/index.js";
import { it } from "../locales/it/index.js";
import { pt } from "../locales/pt/index.js";
import { sw } from "../locales/sw/index.js";

// Available languages
export const SUPPORTED_LANGUAGES = ["en", "es", "bg", "de", "fr", "it", "pt", "sw"];

// Translation resources
const translations = {
	en,
	es,
	bg,
	de,
	fr,
	it,
	pt,
	sw,
};

/**
 * Load translations for a specific language
 * @param {string} language - Language code (en, es, bg, de, fr, it, pt, sw)
 * @returns {Object} Translation object for the language
 */
export const loadTranslation = (language) => {
	if (!SUPPORTED_LANGUAGES.includes(language)) {
		console.warn(`Language '${language}' not supported. Falling back to English.`);
		return translations.en;
	}

	return translations[language];
};

/**
 * Get all available translations
 * @returns {Object} All translation resources
 */
export const getAllTranslations = () => {
	return translations;
};

/**
 * Check if a language is supported
 * @param {string} language - Language code to check
 * @returns {boolean} True if language is supported
 */
export const isLanguageSupported = (language) => {
	return SUPPORTED_LANGUAGES.includes(language);
};
